import gql from 'graphql-tag';
import HelperGraphql from 'utils/helper-graphql'

const fields = {
	'guid': 'String!'
};

export default gql(`
	query app_message( ${ HelperGraphql.createFields( fields ) } ) {
		app_message( ${ HelperGraphql.createVariables( fields ) } ) {
			guid
			date_start
			date_end
			active
			
			translations {
				field
				title
				description
				
				language {
					code
				}
			}
		}
	}
`);

